/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Categories_UpdatedInputs */

const en_directory_launch_categories_updated = /** @type {(inputs: Directory_Launch_Categories_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories updated`)
};

const zh_directory_launch_categories_updated = /** @type {(inputs: Directory_Launch_Categories_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有更新的分类`)
};

/**
* | output |
* | --- |
* | "Categories updated" |
*
* @param {Directory_Launch_Categories_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_categories_updated = /** @type {((inputs?: Directory_Launch_Categories_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Categories_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_categories_updated(inputs)
	return zh_directory_launch_categories_updated(inputs)
});
export { directory_launch_categories_updated as "directory.launch.categories_updated" }